module.exports = __webpack_public_path__ + "static/media/logoGIT.a3f04919.svg";